import { Container } from "reactstrap"
import Breadcrumb from "Components/organisms/breadcrumb"
import LoadingState from "Components/organisms/loading-state"


interface FormPageTemplate {
    title: string
    breadcrumbItem: string
    actions?: React.ReactNode
    form: React.ReactNode
    isLoading: boolean
    loadingTitle?: string
    loadingSubtitle?: string
    modal?: React.ReactNode
}

const FormPageTemplate = ({
    title,
    breadcrumbItem,
    actions,
    form,
    isLoading,
    loadingSubtitle,
    loadingTitle,
    modal
}: FormPageTemplate) => {

    return <div className="page-content">
        <Container fluid style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

            {/* Breadcrumb + Actions */}
            <Breadcrumb
                title={title}
                breadcrumbItem={breadcrumbItem}
                actions={actions}
            />
            {/* Form */}
            <div className="section-container">
                {isLoading ? (
                    <LoadingState
                        title={loadingTitle ?? "Loading Data"}
                        subtitle={loadingSubtitle ?? "Fetching information…"}
                    />
                ) : (form)}
            </div>

            {/* Modal slot */}
            {modal}
        </Container>
    </div>
}

export default FormPageTemplate